module.exports = __webpack_public_path__ + "media/images/laughing-people-c6f49456ee10e9d148531cf193b7aae0.jpg";